module.exports = __webpack_public_path__ + "static/media/applyDataBase.04e0b2a6.jpg";